import { FC } from "react";
import {
  AwesomeCheckIcon,
  CalendarMonthIcon,
  CarWashIcon,
  ClipboardListIcon,
  ClockIcon,
  DocumentIcon,
  FuelStationIcon,
  GpsIcon,
  LeafIcon,
  PersonIcon,
  QuickReferenceIcon,
  SmartphoneIcon,
  SmileIcon,
  StylusNoteIcon,
  CakeIcon,
  TrainingIcon,
  RewardedAdsIcon,
  MopIcon,
  ThumbUpIcon,
  CheckListIcon,
  CircleIcon,
  ContainerIcon,
  IdCardIcon,
  EmojiObjectsIcon,
  NewsIcon,
  EscalatorWarningIcon,
  MinorCrashIcon,
  PhotoCameraIcon,
  FileIcon,
  TextIcon,
  LinkIcon,
  FolderIcon,
  LeaderboardIcon,
  KeyIcon,
  TimetrackerIcon
} from "../../assets/icons/ActionIcons";
import { ActionIconData, ActionItemIcon } from "../../types/actionItem";

export const iconsMap: Record<string, React.FC<ActionItemIcon>> = {
  "person": PersonIcon,
  "carwash": CarWashIcon,
  "smartphone": SmartphoneIcon,
  "checkmark": AwesomeCheckIcon,
  "smile": SmileIcon,
  "training": TrainingIcon,
  "school": TrainingIcon,
  "fuel station": FuelStationIcon,
  "document": DocumentIcon,
  "clipboard": ClipboardListIcon,
  "gps": GpsIcon,
  "leaf": LeafIcon,
  "eco": LeafIcon,
  "clock": ClockIcon,
  "stylus note": StylusNoteIcon,
  "quick reference": QuickReferenceIcon,
  "calendar month": CalendarMonthIcon,
  "cake": CakeIcon,
  "rewarded ads": RewardedAdsIcon,
  "mop": MopIcon,
  "thumb up": ThumbUpIcon,
  "checklist": CheckListIcon,
  "container": ContainerIcon,
  "id card": IdCardIcon,
  "emoji objects": EmojiObjectsIcon,
  "news": NewsIcon,
  "escalator warning": EscalatorWarningIcon,
  "minor crash": MinorCrashIcon,
  "photo camera": PhotoCameraIcon,
  "file": FileIcon,
  "text": TextIcon,
  "url": LinkIcon,
  "folder": FolderIcon,
  "leaderboard": LeaderboardIcon,
  "timetracker": TimetrackerIcon,
  "key": KeyIcon,
  "circle": CircleIcon
};

export const defaultIcons: ActionIconData[] = (() => {
  const seenComponents = new Set<React.FC<ActionItemIcon>>();
  const uniqueIconsList: ActionIconData[] = [];
  for (const iconName of Object.keys(iconsMap)) {
    const IconComponent = iconsMap[iconName];
    if (!seenComponents.has(IconComponent)) {
      seenComponents.add(IconComponent);
      uniqueIconsList.push({ iconName, colorHex: "", iconUrl: null });
    }
  }
  return uniqueIconsList;
})();

const DefaultIcon: FC<ActionIconData> = ({ iconName, colorHex, iconUrl }) => {
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt={iconName}
        style={{
          width: 32,
          height: 32,
          borderRadius: 4,
          objectFit: "contain",
        }}
      />
    );
  }

  const IconComponent = iconsMap[iconName];
  if (IconComponent) {
    return <IconComponent colorHex={colorHex} />;
  }

  console.warn("Unknown icon:", iconName);
  const FallbackIcon = iconsMap["circle"];
  return <FallbackIcon colorHex={colorHex} />;
};

export default DefaultIcon;
